module.exports = __webpack_public_path__ + "static/media/Alastor Moody 1.2302feba.jpg";